import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router'
import { Observable } from 'rxjs/Observable'
import { Store } from '@ngrx/store'
import { map, take } from 'rxjs/operators'

import { AppState } from '../../../store'
import * as Auth from '../store/actions/auth.actions'
import * as fromStore from '../store'

@Injectable()
export class LoggedGuard implements CanActivate {

  constructor(private store: Store<AppState>) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.store.select(fromStore.getAuthLoggedIn).pipe(
      take(1),
      map(loggedIn => {
        const {email} = route.queryParams
        if (loggedIn && !email) { // already loggedin and email is not passed (returnUrl from lost-password)
          this.store.dispatch(new Auth.LoggedInRedirect())
          return false
        }

        if (email) {
          this.store.dispatch(new Auth.Logout({email}))
        }

        return true
      }))
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/guargs/logged.guard.ts